
import { Component, HostListener } from "@angular/core";
import { LayoutService } from "../../../../shared/services/layout.service";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { SuperadminFooterComponent } from "../../superadmin-footer/superadmin-footer.component";
import { SuperadminHeaderComponent } from "../../superadmin-header/superadmin-header.component";
import { SuperadminSidebarComponent } from "../../superadmin-sidebar/superadmin-sidebar.component";
import { HideScrollNavService } from "../../../../shared/services/hidescrollnav.service";
import { SuperAdminNavService } from "../../../../shared/services/superadmin_nav.service";


@Component({
  selector: 'app-superadmin-content',
  imports: [CommonModule, RouterModule, SuperadminFooterComponent, SuperadminHeaderComponent, SuperadminSidebarComponent],
  templateUrl: './superadmin-content.component.html',
  styleUrl: './superadmin-content.component.scss'
})


export class SuperadminContentComponent {

  public innerWidth : number;
  public footerFix = false;
  public footerLight = false;
  public footerDark : boolean = false;

  constructor(
    public navService: SuperAdminNavService,
    public hideScrollNavService: HideScrollNavService,
    public layout : LayoutService,
  ) {}

  ngOnInit (){
    this.innerWidth = window.innerWidth; 
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    if (window.innerWidth < 1200) {
      this.layout.config.settings.sidebar_type = "page-wrapper compact-wrapper";
    }
  } 

  get layoutClass() {
    return (
      this.layout.config.settings.sidebar_type + '' 
    );
  }

  ngDoCheck() {
    if (window.location.pathname == "/page-layout/footer-dark") {
      this.footerDark = true;
      this.footerLight = false;
      this.footerFix = false;
    } else if (window.location.pathname == '/page-layout/footer-light') {
      this.footerLight = true;
      this.footerDark = false;
      this.footerFix = false;
    } else if (window.location.pathname == '/page-layout/footer-fixed') {
      this.footerFix = true;
      this.footerLight = false;
      this.footerDark = false;
    }
  }

  ngOnDestroy() {
    this.footerDark = false;
  }
  
}
